import React, { useState } from 'react';
import { useDelete, useRefresh } from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmActionModal from '../../../components/ConfirmActionModal';

const DeleteButton = ({ record, resource }) => {
  const { id, status } = record;
  const refresh = useRefresh();
  const [deleteQuoteModalOpen, setDeleteQuoteModalOpen] = useState(false);

  const [deleteResource] = useDelete(resource, id, record, {
    onSuccess: () => {
      refresh();
    },
  });

  return (
    status === 'draft' && (
      <>
        <IconButton
          onClick={() => {
            setDeleteQuoteModalOpen(true);
          }}
        >
          <Tooltip title="Delete draft quote">
            <DeleteIcon />
          </Tooltip>
        </IconButton>

        <ConfirmActionModal
          open={deleteQuoteModalOpen}
          mainText="Are you sure you want to delete this whole quote?"
          confirmText="Delete Quote"
          onConfirm={() => {
            deleteResource();
          }}
          onCancel={(e) => {
            e.stopPropagation();
            setDeleteQuoteModalOpen(false);
          }}
        />
      </>
    )
  );
};

export default DeleteButton;
